import { Component, OnInit } from '@angular/core';
import { CatCuentasContablesService } from "../../servicios/cat-cuentas-contables.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatCuentasContables, TipoCuentaContable, CatEstatus, Privilegios } from "../../entidades/entidades";
import { TipoCuentaContableService } from 'app/servicios/tipo-cuenta-contable.service';
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { Router } from "@angular/router";
import { PrivilegiosService } from 'app/servicios/privilegios.service';

@Component({
  selector: 'app-cat-cuentas-contables',
  templateUrl: './cat-cuentas-contables.component.html',
  styleUrls: ['./cat-cuentas-contables.component.css']
})

export class CatCuentasContablesComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  tipoCuentaContable: SelectItem[];
  catCuentasContables: CatCuentasContables[];
  itemsMenu: MenuItem[];
  catEstatus: SelectItem[];
  columnasTabla: any[];
  clonedCatCuentasContables: { [s: string]: CatCuentasContables } = {};
  public cuentaCargoNumber: number;
  privilegios: boolean = false;

  constructor(
   private catCuentasContablesService: CatCuentasContablesService,
    private tipoCuentaContableService: TipoCuentaContableService,
    private router: Router,
    private privilegiosService: PrivilegiosService,
    private catEstatusService: CatEstatusService
   
  ) {}

  async ngOnInit() {
    await this.getAllTipoCuentaContable();
    await this.getAllCatCuentasContables();
    await this.getAllCatEstatus();
    await this.getPrivilegios();

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.guardarGridCatCuentasContables();} },
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getAllCatCuentasContables();} },
    ];

    if(this.privilegios)
      this.itemsMenu.unshift({label: "Agregar",   icon: "pi pi-file-o",  command: () => this.add(), });

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "operacion",header: "Editar", ordenar: false, styleHeader: "width: 30px;"},
      //{field: "id", header: "Id",ordenar: false, styleHeader: "width: 30px;",},
      //{field: "idPadre", header: "Padre",ordenar: true, styleHeader: "width: 150px;",},
      {field: "cuentaCargo", header: "Cuenta Cargo",ordenar: true, styleHeader: "width: 150px;",},
      {field: "descripcion", header: "Descripcion",ordenar: true, styleHeader: "width: 150px;",},
      {field: "idTipoCuentaContable", header: "Tipo Cuenta Contable",ordenar: true, styleHeader: "width: 150px;",},
      {field: "idEstatus", header: "Estatus",ordenar: true, styleHeader: "width: 150px;",},
     // {field: "acciones", header: "",ordenar: false, styleHeader: "width: 30px;",},
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    let catCuentasContablesNew = new CatCuentasContables();
    catCuentasContablesNew.cambio = true;
    catCuentasContablesNew.id = 0;
    catCuentasContablesNew.numRow = this.catCuentasContables.length + 1;
    this.catCuentasContables.unshift(catCuentasContablesNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let catCuentasContablesEdit = event.data;
    this.clonedCatCuentasContables[catCuentasContablesEdit.numRow] = { ...catCuentasContablesEdit };
    catCuentasContablesEdit.cambio = true;
    catCuentasContablesEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let catCuentasContablesEdit = event.data;
    let index = this.catCuentasContables.findIndex(
      (obj) => obj.numRow === catCuentasContablesEdit.numRow
    );
    this.catCuentasContables[index] = { ...this.clonedCatCuentasContables[catCuentasContablesEdit.numRow]};
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let catCuentasContablesEdit = event.data;

      //Valida si hay cambios
      if (
        catCuentasContablesEdit.id === this.clonedCatCuentasContables[catCuentasContablesEdit.numRow].id &&
        catCuentasContablesEdit.idPadre === this.clonedCatCuentasContables[catCuentasContablesEdit.numRow].idPadre &&
        catCuentasContablesEdit.cuentaCargo === this.clonedCatCuentasContables[catCuentasContablesEdit.numRow].cuentaCargo &&
        catCuentasContablesEdit.descripcion === this.clonedCatCuentasContables[catCuentasContablesEdit.numRow].descripcion &&
        catCuentasContablesEdit.idTipoCuentaContable === this.clonedCatCuentasContables[catCuentasContablesEdit.numRow].idTipoCuentaContable &&
        catCuentasContablesEdit.idEstatus === this.clonedCatCuentasContables[catCuentasContablesEdit.numRow].idEstatus 
      ) {
        let index = this.catCuentasContables.findIndex((obj) => obj.numRow === catCuentasContablesEdit.numRow);
        this.catCuentasContables[index] = {...this.clonedCatCuentasContables[catCuentasContablesEdit.numRow]};
        return;
      }

      //Validaciones
      //throw new Error("No paso las validaciones.");

      catCuentasContablesEdit.cambio = true;
      catCuentasContablesEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridCatCuentasContables() {
    try {

      for (let catCuentasContables of this.catCuentasContables) {
        console.log(typeof catCuentasContables.cuentaCargo);
        if (catCuentasContables.baja) {
          await this.deleteCatCuentasContables(catCuentasContables);
        } else if (catCuentasContables.cambio) {
          catCuentasContables.cambio = false;
          this.clonedCatCuentasContables[catCuentasContables.id] = { ...catCuentasContables, };
         if (catCuentasContables.id === 0) {
            const valor = catCuentasContables.cuentaCargo;
            catCuentasContables.cuentaCargo = Number(valor);
            console.log("datos: ", catCuentasContables);
            await this.addCatCuentasContables(catCuentasContables);
          } else {
            await this.updateCatCuentasContables(catCuentasContables);
          }
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCatCuentasContables");
    }
  }

  // prettier-ignore
  async addCatCuentasContables(catCuentasContables) {
    try {
      await this.catCuentasContablesService.add(catCuentasContables).toPromise();
      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCatCuentasContables");
    }
  }


  // prettier-ignore
  async getAllCatCuentasContables() {
    try {
      console.log("inicia getCatCuentasContables");
      const datoRetorno = await this.catCuentasContablesService.getAll().toPromise();
      console.log("RETORNA: ", datoRetorno);
      this.catCuentasContables = datoRetorno;
      
      for (var i = 0, len = this.catCuentasContables.length; i < len; ++i){
        this.catCuentasContables[i].numRow = i;
        this.clonedCatCuentasContables[this.catCuentasContables[i].numRow] = {...this.catCuentasContables[i],        };
      }
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatCuentasContables");
    }
  }

  // prettier-ignore
  async updateCatCuentasContables(catCuentasContables: CatCuentasContables) {
    try {
      const datoRetorno = await this.catCuentasContablesService
        .update(catCuentasContables)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCatCuentasContables");
    }
  }

  // prettier-ignore
  async deleteCatCuentasContables(catCuentasContables: CatCuentasContables) {
    try {
      const datoRetorno = await this.catCuentasContablesService
        .delete(catCuentasContables.id)
        .toPromise();
      this.getAllCatCuentasContables();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCatCuentasContables");
    }
  }

  

  // prettier-ignore
  async getAllTipoCuentaContable() {
    try {
      const datoRetorno = await this.tipoCuentaContableService.getAll().toPromise();
      this.tipoCuentaContable = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.tipoCuentaContable.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getTipoCuentaContable");
    }
  }

  async getAllCatEstatus() {
    try {
      const datoRetorno = await this.catEstatusService.getAll().toPromise();
      this.catEstatus = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catEstatus.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstatus");
    }
  }

  async getPrivilegios() {
        try {
    
          let objUrl = new Privilegios();
          objUrl.descripcion = this.router.url + '/consulta_edicion';
          let consultaRemesa = await this.privilegiosService.GetPrivilegioByRoute(objUrl).toPromise();
          this.privilegios = consultaRemesa ? true : false; 
        } catch (e) {
          if (e.response) throw { message: e.response.data };
          else throw e;
        } finally {
          console.log("Paso por getPrivilegios");
        }
  }

}
